module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av330-a72084eb1f6a20fcf4f81717640dcb9d.jpg";